module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('popover', {
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "placement": "top"
    },
    on: {
      "on-show": _vm.onShow,
      "on-hide": _vm.onHide
    }
  }, [_c('div', {
    staticClass: "popover-demo-content",
    slot: "content"
  }, [_vm._v("\n      hello world\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Popover on top")])]), _vm._v(" "), _c('popover', {
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "placement": "bottom"
    }
  }, [_c('div', {
    staticClass: "popover-demo-content",
    slot: "content"
  }, [_vm._v("\n      hello world\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Popover on bottom")])]), _vm._v(" "), _c('popover', {
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "placement": "left"
    }
  }, [_c('div', {
    staticClass: "popover-demo-content",
    slot: "content"
  }, [_vm._v("\n      hello world\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Popover on left")])]), _vm._v(" "), _c('popover', {
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "placement": "right"
    }
  }, [_c('div', {
    staticClass: "popover-demo-content",
    slot: "content"
  }, [_vm._v("\n      hello world\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Popover on right")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-159ae072"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/popover/DemoIndex.vue
// module id = 471
// module chunks = 4